// Ported from vouchers' danger-zone-section.tsx, on kore's destructive token
// instead of the shadcn one so it themes with the rest of a kore page.

import { Button } from "@pej/kore/components";

export interface DangerZoneSectionProps {
    /** Heading text. Defaults to "Danger zone". */
    title?: string;
    /** Button label. Defaults to "Delete". */
    action?: string;
    /** What the destructive action does and its consequences. */
    description: string;
    disabled?: boolean;
    onDelete: () => void;
}

/**
 * Panel for destructive entity-level actions. Rendered last on a page so it
 * sits below all primary content, with a red-tinted border as a standing
 * signal of a destructive region.
 */
export function DangerZoneSection({
    title = "Danger zone",
    action = "Delete",
    description,
    disabled,
    onDelete,
}: DangerZoneSectionProps) {
    return (
        <section className="space-y-3 rounded-kore-md border border-kore-destructive/30 bg-kore-destructive/5 p-5">
            <h2 className="text-lg font-semibold text-kore-destructive">{title}</h2>
            <div className="flex items-center justify-between gap-4">
                <p className="text-sm text-kore-text-muted">{description}</p>
                <Button type="button" variant="destructive" size="sm" onClick={onDelete} disabled={disabled}>
                    {action}
                </Button>
            </div>
        </section>
    );
}
